var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.componentClass,
      style: _vm.componentStyle,
      attrs: { role: "alert", size: _vm.size },
    },
    [
      _vm.hasIcon
        ? [
            _vm.iconName === "faBlockQuestion"
              ? _c("owa-question-mark-block", {
                  staticClass: "decorative",
                  attrs: { "block-size": _vm.iconSize },
                })
              : _c("font-awesome-icon", {
                  staticClass: "decorative",
                  attrs: {
                    icon: _vm.$v7[_vm.iconStyle][_vm.iconName],
                    "icon-size": _vm.iconSize,
                    spin: _vm.isIconSpinning,
                  },
                }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._t("title", function () {
        return [
          _vm.hasTitle
            ? _c("h3", { staticClass: "h5" }, [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
              ])
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm._t("content", function () {
        return [
          _vm.hasContent
            ? _c("p", { staticStyle: { "--paragraph-margin-bottom": "0" } }, [
                _vm._v("\n      " + _vm._s(_vm.content) + "\n    "),
              ])
            : _vm._e(),
        ]
      }),
      _vm._v(" "),
      _vm.isDismissable
        ? _c(
            "button",
            {
              staticClass: "close",
              attrs: {
                type: "button",
                "aria-label": "Close",
                "data-balloon-pos": "left",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticStyle: { "--fa-width": "auto" },
                attrs: { icon: _vm.$v7.duotone.faCircleXmark },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }